import React, { Component } from 'react';

export class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            username: '',
            password: '',
            error: '',
            loading: false
        };
    }

    handleChange(e) {
        this.setState({ [e.target.name]: e.target.value, error: '' });
    }

    async handleSubmit(e) {
        e.preventDefault();
        this.setState({ loading: true, error: '' });

        try {
            const response = await fetch('api/auth/login', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    username: this.state.username,
                    password: this.state.password
                })
            });
            const data = await response.json();

            if (data.success) {
                localStorage.setItem('token', data.token);
                localStorage.setItem('username', this.state.username);
                localStorage.setItem('displayName', data.displayName);
                localStorage.setItem('role', data.role);
                window.location.href = '/console';
            } else {
                this.setState({ error: data.message, loading: false });
            }
        } catch {
            this.setState({ error: 'ไม่สามารถเชื่อมต่อเซิร์ฟเวอร์ได้', loading: false });
        }
    }

    render() {
        const { username, password, error, loading } = this.state;
        return (
            <div style={{
                minHeight: '100vh',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 50%, #0f3460 100%)'
            }}>
                <div style={{
                    background: '#fff',
                    borderRadius: '12px',
                    padding: '40px',
                    width: '100%',
                    maxWidth: '400px',
                    boxShadow: '0 20px 60px rgba(0,0,0,0.3)'
                }}>
                    <div style={{ textAlign: 'center', marginBottom: '30px' }}>
                        <img src="/images/ANT_LOGO.png" alt="ANT" style={{ width: '80px', marginBottom: '15px' }} />
                        <h4 style={{ color: '#333', margin: 0 }}>ANT Journey Console</h4>
                        <p style={{ color: '#999', fontSize: '14px' }}>เข้าสู่ระบบจัดการ</p>
                    </div>

                    <form onSubmit={e => this.handleSubmit(e)}>
                        {error &&
                            <div className="alert alert-danger py-2" style={{ fontSize: '14px' }}>
                                {error}
                            </div>
                        }
                        <div className="form-group mb-3">
                            <label style={{ fontSize: '14px', color: '#555' }}>Username</label>
                            <input
                                type="text"
                                name="username"
                                className="form-control"
                                value={username}
                                onChange={e => this.handleChange(e)}
                                placeholder="กรอก username"
                                autoFocus
                            />
                        </div>
                        <div className="form-group mb-4">
                            <label style={{ fontSize: '14px', color: '#555' }}>Password</label>
                            <input
                                type="password"
                                name="password"
                                className="form-control"
                                value={password}
                                onChange={e => this.handleChange(e)}
                                placeholder="กรอก password"
                            />
                        </div>
                        <button
                            type="submit"
                            className="btn btn-primary btn-block w-100"
                            disabled={loading}
                            style={{ padding: '10px', fontSize: '16px' }}
                        >
                            {loading ? 'กำลังเข้าสู่ระบบ...' : 'เข้าสู่ระบบ'}
                        </button>
                    </form>
                </div>
            </div>
        );
    }
}
